import GraphX6, {IGraphOptions} from './graph/GraphX6';

export default class ViewerX6 {
	_options: IGraphOptions;
	_graphService: GraphX6;
	_container: HTMLElement | null;

	constructor(options: IGraphOptions = {}) {
		this._options = options;
		this._graphService = new GraphX6(options);
		this._container = null;
	}

	attachTo(container: HTMLElement) {
		this._container = container;
		this._graphService.init(container, this);
	}

	detach() {
		this._graphService.destroy();
		this._container = null;
	}

	getGraph() {
		return this._graphService.getGraph();
	}

	getDnd() {
		return this._graphService.getDnd();
	}

	getSelection() {
		return this._graphService.getSelection();
	}
}
